import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import EditProfileForm from "@/features/profile/EditProfileForm";

export default function Profile() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            href: "/profile",
            label: "Profile",
          },
          {
            label: "Profile",
          },
        ]}
      />
      <H2>Profile</H2>
      <EditProfileForm />
    </>
  );
}
